<div class="card">
    <div class="font-semibold text-xl mb-4">Gestion de la bankroll</div>
    <p>Suivez l'évolution de vos paris et analysez vos performances financières.</p>
</div>

<div class="card">
    <div class="bg-white rounded-lg shadow mb-8">
        <div class="p-6 border-b border-gray-200">
            <div class="flex justify-between flex-col lg:flex-row items-center">
                <h2 class="text-xl font-semibold text-gray-800 mb-4 lg:mb-0">
                    <i class="pi pi-chart-line mr-2 text-blue-500"></i>
                    Évolution de votre ROI
                </h2>
                <div class="flex flex-col sm:flex-row items-center gap-4">
                    <!-- Sélection de période -->
                    <div class="flex items-center gap-2">
                        <label class="text-sm font-medium text-gray-600">Période :</label>
                        <p-dropdown [options]="periodOptions" [ngModel]="selectedPeriod()"
                            (ngModelChange)="onPeriodChange({ value: $event })" optionLabel="label" optionValue="value"
                            placeholder="Choisir une période" styleClass="w-44">
                        </p-dropdown>
                    </div>

                    <div class="flex gap-3">
                        <p-button label="Ajouter un pari" severity="success" (onClick)="openNew()" />
                    </div>
                </div>
            </div>

            <div class="p-6">
                <div *ngIf="lineData" style="height: 400px;">
                    <p-chart type="line" [data]="lineData" [options]="lineOptions"
                        [style]="{ width: '100%', height: '500px', display: 'block' }">
                    </p-chart>
                </div>

                <div *ngIf="!lineData" class="text-center py-12">
                    <i class="pi pi-chart-line text-4xl text-gray-300 mb-4"></i>
                    <p class="text-gray-500">Aucune donnée disponible</p>
                    <button type="button" (click)="loadParisData()"
                        class="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
                        Actualiser
                    </button>
                </div>
            </div>

            <div *ngIf="lineData" class="px-6 pb-6">
                <div class="bg-gray-50 rounded-lg p-4">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="flex items-center">
                            <div class="w-4 h-4 bg-blue-500 rounded mr-3"></div>
                            <span class="text-sm text-gray-600">
                                <strong>ROI :</strong> Évolution de votre retour sur investissement
                            </span>
                        </div>

                    </div>

                    <div class="mt-4 pt-4 border-t border-gray-200">
                        <p class="text-xs text-gray-500">
                            <i class="pi pi-info-circle mr-1"></i>
                            Données basées sur {{nombreDeParis}} paris •
                            ROI actuel : {{roi}}%
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">


    <div class="grid grid-cols-12 gap-6 md:gap-8 xl:gap-10 justify-center mb-10">
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <div class="card mb-0 p-4 cursor-pointer" (click)="showDialog()">
                <div class="flex justify-between mb-4">
                    <div class="flex-1 flex items-center flex-col">
                        <span class="block text-muted-color text-center font-medium mb-4">Paris</span>
                        <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">{{nombreDeParis}}
                        </div>
                    </div>
                    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
                        style="width: 2.5rem; height: 2.5rem">
                        <i class="pi pi-info-circle text-blue-500 !text-xl"></i>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <div class="card mb-0 p-4">
                <div class="flex justify-between mb-4">
                    <div class="flex-1 flex items-center flex-col">
                        <span class="block text-muted-color text-center font-medium mb-4">P&L</span>
                        <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">{{capitalActuelle}}
                        </div>
                    </div>
                    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border cursor-pointer"
                        style="width: 2.5rem; height: 2.5rem" (click)="showDialog()">
                        <i class="pi pi-info-circle text-blue-500 !text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <div class="card mb-0 p-4">
                <div class="flex justify-between mb-4">
                    <div class="flex-1 flex items-center flex-col">
                        <span class="block text-muted-color text-center font-medium mb-4">Totale Mise</span>
                        <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">{{totalMises}}</div>
                    </div>
                    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border cursor-pointer"
                        style="width: 2.5rem; height: 2.5rem" (click)="showDialog()">
                        <i class="pi pi-info-circle text-blue-500 !text-xl"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-span-12 md:col-span-6 xl:col-span-3">
            <div class="card mb-0 p-4">
                <div class="flex justify-between mb-4">
                    <div class="flex-1 flex items-center flex-col">
                        <span class="block text-muted-color text-center font-medium mb-4">ROI</span>
                        <div class="text-surface-900 dark:text-surface-0 font-medium text-2xl">{{roi}} %</div>
                    </div>
                    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border cursor-pointer"
                        style="width: 2.5rem; height: 2.5rem" (click)="showDialog()">
                        <i class="pi pi-info-circle text-blue-500 !text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-table #dt [value]="listOfParis()" [rows]="10" [paginator]="true"
    [globalFilterFields]="['name', 'country.name', 'representative.name', 'status']"
    [tableStyle]="{ 'min-width': '75rem' }" [rowHover]="true" dataKey="id"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} probabilities" [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 30]">
    <ng-template #caption>
        <div class="flex items-center justify-between">
            <h5 class="m-0">Gestion de la bankroll</h5>

        </div>
    </ng-template>
    <ng-template #header>
        <tr>

            <th pSortableColumn="name" style="min-width:10rem">
                Date
            </th>
            <th>Evénement</th>
            <th pSortableColumn="price" style="min-width: 16rem">
                Nombre de paris
            </th>
            <th pSortableColumn="category" style="min-width:10rem">
                Cote
            </th>


            <th pSortableColumn="inventoryStatus" style="min-width: 7rem">
                Mise

            </th>
            <th style="min-width: 16rem">status

            <th style="min-width: 12rem"></th>
        </tr>
    </ng-template>
    <ng-template #body let-pari>
        <tr>


            <td style="min-width: 12rem">{{ pari.event_date | date:'shortDate' }} </td>
            <td style="min-width: 16rem">{{ pari.event_name }}</td>

            <td>
                {{pari.nbr_paris}}
            </td>

            <td>{{ pari.cote }}</td>
            <td>{{ pari.mise }}</td>


            <td>
                <p-tag [value]="pari.status" [severity]="getSeverity(pari.status)" />
            </td>
            <td>
                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [outlined]="true"
                    (click)="editParis(pari)" />
                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                    (click)="deleteParis(pari)" />
            </td>
        </tr>
    </ng-template>
</p-table>


<p-dialog [(visible)]="pariDialog" [style]="{ width: '450px' }" header="Informations Pari" [modal]="true">
    <ng-template #content>
        <div class="flex flex-col gap-6">

            <div>
                <label for="event_date" class="block font-bold mb-3">Date</label>
                <p-datepicker [(ngModel)]="pari.event_date" required fluid />
                <small class="text-red-500" *ngIf="submitted && !pari.event_date">Date est requise.</small>
            </div>
            <div>
                <label for="event_name" class="block font-bold mb-3">Intitulé du pari</label>
                <input type="text" class="text-[16px]" pInputText id="event_name" [(ngModel)]="pari.event_name" required
                    autofocus fluid />
                <small class="text-red-500" *ngIf="submitted && !pari.event_name">Le nom est requis.</small>
            </div>

            <div>
                <label for="status" class="block font-bold mb-3">Status</label>
                <p-select [(ngModel)]="pari.status" inputId="status" [options]="statuses" optionLabel="label"
                    optionValue="label" placeholder="Sélectionner un statut" fluid />
            </div>

            <div>
                <span class="block font-bold mb-4">Nombre de paris</span>
                <input id="nbr_paris" [(ngModel)]="pari.nbr_paris" type="number" pInputText
                    class="p-2 border rounded w-full text-[16px]" />
            </div>

            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-6">
                    <label for="cote" class="block font-bold mb-3">Cote</label>
                    <p-inputNumber id="cote" [(ngModel)]="pari.cote" [minFractionDigits]="1" [maxFractionDigits]="2"
                        [useGrouping]="false" inputMode="decimal" [locale]="'fr-FR'" fluid>
                    </p-inputNumber>
                </div>
                <div class="col-span-6">
                    <label for="mise" class="block font-bold mb-3">Mise</label>
                    <p-inputnumber id="mise" [(ngModel)]="pari.mise" fluid />
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
        <p-button label="{{!isEditMode ? 'Créer' : 'Mise à jour'}}" icon="pi pi-check" (click)="createParis()" />
    </ng-template>
</p-dialog>

<p-toast [position]="isMobile ? 'bottom-center' : 'top-right'" />

<p-dialog header="Confirmer l'annulation" [(visible)]="cancelDialogParis" modal [closable]="false">
    <p>Êtes-vous sûr de vouloir supprimer le paris ? </p>


    <ng-template pTemplate="footer">
        <button pButton type="button" label="Fermer" (click)="cancelDialogParis = false" class="p-button-text"></button>
        <button pButton type="button" label="Confirmer" (click)="confirmCancel()" class="p-button-danger"></button>
    </ng-template>
</p-dialog>